import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-account-closure';

const list = (merchantId, params) =>
	Client.get(`${baseUrl}/${merchantId}/account-closures`, params);

const reopen = (merchantId, id, data) =>
	Client.put(`${baseUrl}/${merchantId}/account-closures/${id}/reopen`, data);

export default {
	list,
	reopen,
};
